<template>
  <div class="step-container">
    <ul class="steps">
      <li
        v-for="(index, key) in steps"
        :key="key"
        :class="['step', { active: currentIndex(index)}]"
      >
        <span> {{ index }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      totalCount: {
        type: Number,
        required: true
      },
      activeStep: {
        type: Number,
        required: false,
        default: 1
      }
    },
    data() {
      return {
        steps: []
      }
    },
    mounted () {
      for (let step = 1; step <= this.totalCount; step++) {
        this.steps.push(step)
      }
    },
    methods: {
      currentIndex(index) {
        if (!this.steps.includes(this.activeStep) && index === 1) {
          return true
        }
        return this.activeStep === index
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .step-container {
    display: block;
    width: 100%;
    max-width: 168px;
    margin: 0 auto 16px;
    position: relative;
    padding-top: 20px;

    &::before {
      content: "";
      display: block;
      position: absolute;
      bottom: 13px;
      width: 100%;
      height: 2px;
      background-color: $gray-light-brown;
    }

    @include bp-mf-tablet {
      margin-bottom: 23px;
    }

    @include bp-mf-desktop {
      margin-bottom: 19px;
    }

    .steps {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .step {
      width: 26px;
      height: 26px;
      position: relative;
      content: "";
      margin: 0;
      border: 1px solid $gray-light-brown;
      border-radius: 50%;
      background-color: #fff;
      display: flex;
      justify-content: center;

      &.active {
        border: 2px solid $green-base;
      }

      span {
        align-self: center;
        font-size: em(12);
        font-weight: 500;
        line-height: 14px;
        text-align: center;
        color: $blue-dark;
      }
    }
  }
</style>
